import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@shared/@fuse/shared.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule, MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslateModule } from '@ngx-translate/core';
import { FileUploadAWSComponent } from './components/file-upload-aws/file-upload-aws.component';
import { ModalDialogContainerComponent } from './components/modal-dialog-container/modal-dialog-container.component';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { HeaderPageModule } from '@layouts/components/header/header-page.module';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { EightCapCardComponent } from './components/eight-cap-card/eight-cap-card.component';
import { AccountReadService } from './services/account-read.service';
import { EigPaginatorDirective } from './components/eig-table/eig-paginator.directive';
import { EigBlockUIDirective } from './components/eig-block-ui/eig-block-ui.directive';
import { EigProgressSpinnerComponent } from './components/eig-progress-spinner/eig-progress-spinner.component';
import { CommonModule } from '@angular/common';
import { EigTableEmptyDirective } from './components/eig-table/eig-table-emty.directive';
import { NgxMaskModule } from 'ngx-mask';
import { EigDetailTableComponent } from './components/eig-detail-table/eig-detail-table.component';
import { CardModule } from 'ngx-card/ngx-card';
import { LookupNamePipe } from './pipe/lookup-name.pipe';
import { SwitchingDialogService } from './services/dialog-type.service';
import { ModalComponent } from './@fuse/components/dialog/modal.component';
import { ResetUserInformation } from '@modules/user/components/reset-user-information/reset-user-information.component';
import {
    WatchDogAddComponent
} from '@modules/monitoring/pages/watchdog-fingerprint/watchdog-add/watchdog-add.component';
import { OnlyDigitsDirective } from './directives/digits-only.directive';
import { RefundTableComponent } from './components/refund-table/refund-table.component';
import { EigCheckboxGroupComponent } from './components/eig-checkbox-group/eig-checkbox-group.component';
import { EigScrollToLastDirective } from './directives/scroll-to-last.directive';
import { GetHeightPipe } from './pipe/get-height.pipe';
import { DynamicJsonFormComponent } from './components/dynamic-json-form/dynamic-json-form.component';
import { SelectCheckAllComponent } from './components/select-check-all/select-check-all.component';
import { FocusAfterRenderDirective } from './directives/focus-after-render.directive';
import { EigVirtualScrollDynamicHeightDirective } from './directives/virtual-scroll-dynamic-height.directive';
import {
    CreateModalActionComponent
} from './components/modal-action/create-modal-action/create-modal-action.component';
import {
    DetailsModalActionComponent
} from './components/modal-action/details-modal-action/details-modal-action.component';
import { EditModalActionComponent } from './components/modal-action/edit-modal-action/edit-modal-action.component';
import { TrimDirective } from './directives/trim.directive';
import { FilterFormActionsComponent } from '@eightcap/ui/filter-form-actions/filter-form-actions.component';
import { CountryNamePipe } from './pipe/country-name.pipe';
import { SortPipe } from './pipe/sort.pipe';
import { ModulePermissionService } from './services/module-permission.service';

const MaterialModules = [
    MatAutocompleteModule,
    MatBadgeModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatMomentDateModule,
    MatOptionModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule
];

@NgModule({
    declarations: [
        CreateModalActionComponent,
        DynamicJsonFormComponent,
        DetailsModalActionComponent,
        EditModalActionComponent,
        EigBlockUIDirective,
        EigCheckboxGroupComponent,
        EigDetailTableComponent,
        EightCapCardComponent,
        EigPaginatorDirective,
        EigProgressSpinnerComponent,
        EigScrollToLastDirective,
        EigTableEmptyDirective,
        FileUploadAWSComponent,
        GetHeightPipe,
        LookupNamePipe,
        CountryNamePipe,
        ModalComponent,
        ModalDialogContainerComponent,
        OnlyDigitsDirective,
        RefundTableComponent,
        ResetUserInformation,
        WatchDogAddComponent,
        SelectCheckAllComponent,
        SortPipe,
        FocusAfterRenderDirective,
        EigVirtualScrollDynamicHeightDirective,
        TrimDirective,
        FilterFormActionsComponent
    ],
    imports: [
        CardModule,
        CommonModule,
        FuseSharedModule,
        HeaderPageModule,
        MaterialModules,
        NgxMaskModule.forRoot(),
        SweetAlert2Module,
        TranslateModule
    ],
    exports: [
        CardModule,
        CreateModalActionComponent,
        DetailsModalActionComponent,
        DynamicJsonFormComponent,
        EditModalActionComponent,
        EigBlockUIDirective,
        EigCheckboxGroupComponent,
        EigDetailTableComponent,
        EightCapCardComponent,
        EigPaginatorDirective,
        EigScrollToLastDirective,
        EigTableEmptyDirective,
        FileUploadAWSComponent,
        FuseSharedModule,
        GetHeightPipe,
        HeaderPageModule,
        LookupNamePipe,
        CountryNamePipe,
        MaterialModules,
        ModalDialogContainerComponent,
        NgxMaskModule,
        NgxMatSelectSearchModule,
        OnlyDigitsDirective,
        RefundTableComponent,
        SweetAlert2Module,
        TranslateModule,
        SelectCheckAllComponent,
        SortPipe,
        FocusAfterRenderDirective,
        EigVirtualScrollDynamicHeightDirective,
        TrimDirective,
        FilterFormActionsComponent
    ],
    providers: [
        AccountReadService,
        SwitchingDialogService,
        ModulePermissionService,
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                appearance: 'outline'
            }
        },
        {
            provide: MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS,
            useValue: {
                diameter: 30,
                strokeWidth: 2
            }
        }
    ]
})
export class SharedModule {}
